import { Cpu, Sparkles, Rocket, ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { IMAGES, waLink } from "../config";

const cardBase =
    "group relative overflow-hidden rounded-3xl border border-slate-200/80 bg-white shadow-xl shadow-sky-900/5 transition-all duration-500 hover:shadow-2xl hover:shadow-sky-500/15 hover:-translate-y-1";

export const Activities = () => (
    <section id="attivita" data-testid="activities-section" className="py-20 sm:py-28 bg-gradient-to-b from-white to-[#E0F7FA]/40">
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
            <Reveal className="max-w-2xl">
                <SectionLabel>Le mie attività</SectionLabel>
                <h2
                    data-testid="activities-heading"
                    className="mt-5 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#03045E]"
                >
                    Tre mondi, un unico obiettivo:
                    <span className="text-gradient-azure"> la tua crescita.</span>
                </h2>
            </Reveal>

            <div className="mt-12 grid gap-5 md:grid-cols-3">
                <Reveal className="md:col-span-2" delay={0.05}>
                    <article data-testid="activity-card-ai" className={`${cardBase} h-full min-h-[320px] flex flex-col justify-end`}>
                        <img
                            src={IMAGES.aiWave}
                            alt=""
                            aria-hidden="true"
                            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#03045E]/95 via-[#03045E]/55 to-[#03045E]/10" />
                        <div className="relative p-7 sm:p-9">
                            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#48CAE4]/20 border border-[#48CAE4]/40 text-[#90E0EF] backdrop-blur-sm">
                                <Sparkles className="h-6 w-6" />
                            </span>
                            <h3 className="mt-5 font-display text-xl sm:text-2xl font-bold text-white">
                                Intelligenza Artificiale Performance
                            </h3>
                            <p className="mt-3 max-w-md text-sm sm:text-base text-sky-100/85 leading-relaxed">
                                Workflow intelligenti, prompt engineering e automazione
                                con IA generativa per moltiplicare la qualità e la
                                velocità del tuo lavoro.
                            </p>
                        </div>
                    </article>
                </Reveal>

                <Reveal delay={0.15}>
                    <article data-testid="activity-card-tech" className={`${cardBase} h-full p-7 flex flex-col`}>
                        <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-sky-100 text-[#0077B6] transition-colors duration-300 group-hover:bg-[#0077B6] group-hover:text-white">
                            <Cpu className="h-6 w-6" />
                        </span>
                        <h3 className="mt-5 font-display text-xl font-bold text-[#03045E]">
                            Tecnologia & Innovazione
                        </h3>
                        <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">
                            Strumenti digitali moderni e processi di trasformazione
                            tecnologica per portare il tuo business nel futuro, senza
                            complessità inutili.
                        </p>
                    </article>
                </Reveal>

                <Reveal delay={0.1}>
                    <article data-testid="activity-card-creator" className={`${cardBase} h-full p-7 flex flex-col`}>
                        <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-sky-100 text-[#0077B6] transition-colors duration-300 group-hover:bg-[#0077B6] group-hover:text-white">
                            <Rocket className="h-6 w-6" />
                        </span>
                        <h3 className="mt-5 font-display text-xl font-bold text-[#03045E]">
                            Opportunità per Creator e Aziende
                        </h3>
                        <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">
                            Modelli di monetizzazione, partnership con i brand e
                            consulenza strategica per trasformare la tua presenza
                            online in un'attività solida.
                        </p>
                    </article>
                </Reveal>

                <Reveal className="md:col-span-2" delay={0.2}>
                    <article data-testid="activity-card-cta" className={`${cardBase} h-full min-h-[260px] flex flex-col justify-end`}>
                        <img
                            src={IMAGES.creatorStudio}
                            alt="Studio di creazione contenuti"
                            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-r from-[#03045E]/95 via-[#03045E]/70 to-[#0077B6]/30" />
                        <div className="relative p-7 sm:p-9 flex flex-col sm:flex-row sm:items-end gap-5 justify-between">
                            <div>
                                <h3 className="font-display text-xl sm:text-2xl font-bold text-white">
                                    Hai un progetto in mente?
                                </h3>
                                <p className="mt-2 max-w-sm text-sm sm:text-base text-sky-100/85">
                                    Raccontamelo su WhatsApp: capiamo insieme come
                                    l'IA può accelerarlo.
                                </p>
                            </div>
                            <a
                                href={waLink("Ciao Maria! Ho un progetto in mente e vorrei parlarne con te.")}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="activity-cta-button"
                                className="inline-flex shrink-0 items-center gap-2 px-6 py-3.5 rounded-full text-sm font-semibold bg-white text-[#03045E] hover:bg-[#48CAE4] transition-colors duration-300"
                            >
                                Parliamone
                                <ArrowUpRight className="h-4 w-4" />
                            </a>
                        </div>
                    </article>
                </Reveal>
            </div>
        </div>
    </section>
);
